// extracted by mini-css-extract-plugin
export var footer = "_pc-5";
export var fulfillmentInput = "_pc-0";
export var shipDateInput = "_pc-1";
export var shipmentModal = "_pc-2";
export var shipmentModalContent = "_pc-3";
export var tableContainer = "_pc-4";